// Phase DP polish 1a — friendly display label for a canonical
// payment-method token. Storage stays as the lowercase canonical form
// (``ach`` / ``cash`` / ``check`` / ``credit_card`` / ``other``);
// callers use this helper for any user-facing label.
//
// Unknown tokens fall back to a titlecased version with underscores
// turned into spaces (so a future ``bank_wire`` renders as
// ``Bank Wire`` without code changes).
const KNOWN = {
    ach: "ACH",
    cash: "Cash",
    check: "Check",
    credit_card: "Credit Card",
    other: "Other",
};

export function paymentMethodLabel(canonical) {
    if (canonical == null) return "—";
    const key = String(canonical).trim().toLowerCase();
    if (key === "") return "—";
    if (KNOWN[key]) return KNOWN[key];
    // Fallback: titlecase, underscores → spaces.
    return key
        .split("_")
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
}

// Phase J.4b-FIX (2026-07-31) — extract the default-bank pick logic out
// of ``AdminInvoiceDetailPage`` so we can unit-test the contract with
// the ``/admin/customers/{id}/payment-methods`` endpoint. The endpoint
// returns ``{items:[...], default_payment_method_id, stripe_customer_id}``
// — reading ``saved_payment_methods`` (the shape from the CUSTOMER DETAIL
// endpoint) instead of ``items`` was the source of a P0 regression where
// the "Charge ACH now" button never rendered on a fully-verified customer.
//
// Returns ``{last4, bank_name} | null``.
export function pickDefaultBankFromMethodsResponse(data) {
    if (!data || typeof data !== "object") return null;
    const items = Array.isArray(data.items) ? data.items : [];
    if (items.length === 0) return null;
    const defaultId = data.default_payment_method_id;
    const def = items.find((p) => p && p.id === defaultId)
        || items.find((p) => p && p.is_default);
    if (!def) return null;
    return {
        last4: def.last4 || "····",
        bank_name: def.bank_name || "Bank",
    };
}
